import React, { useMemo } from 'react';
import { Badge } from '@zeal/web-ui';
import { useTranslation } from 'react-i18next';
import { NotificationPriority } from '../types';

export function PriorityBadge({
	priority,
}: {
	priority: NotificationPriority;
}) {
	const { t } = useTranslation('common');

	const badge = useMemo(() => {
		switch (priority) {
			case 5:
				return (
					<Badge type="basic" variant="warning">
						{t('crucial')}
					</Badge>
				);
			default:
				return <></>;
		}
	}, [priority, t]);

	return badge;
}
